import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { useHistory } from "react-router-dom";

import "./style.scss";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { getStepperTooltipData } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import Box from "@material-ui/core/Box";

import axios from "axios";
import { COHORT_NAME_LIST } from "../../../../common/constants/ApplicationUrl";
import api from "../../../../common/dependencies/utils/Api";

import AnimeList from "../../StartupDashboard/ViewAllMentorList/AnimeList";

import iconTooltip from "../../../../../assets/svg/dashboard/iconTooltip.svg";
import LineWithDot from "../../../../../assets/images/Line wit Dot.svg";
import Pagination from "react-js-pagination";
import { Button as MaterialButton } from "@material-ui/core";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import { Country, State } from "country-state-city";

import CohortDetail from "../../../../../assets/svg/dashboard/Cohort-Details.svg";
import { getMentorCohortApplicationList } from "../dependencies/action";
import editIcon from "../../../../../assets/svg/editIconCircle.svg";

import { getPredefineOptionsList } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import * as moment from "moment";
import Modal from "../../StartupDashboard/MyRequests/Modal/modal";
import Select from "react-select";
import Button from "../../AdminDashboard/Button";
import {
  getNamesList,
  getCohortApplicationCounter,
} from "../../AdminDashboard/AdminMentorAction/dependencies/action";
const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "500px",
    paddingTop: "30px",
    paddingBottom: "150px",
    backgroundColor: "#f0f3f5",
    position: "relative",
  },
  headingOne: {
    fontSize: "28px",
    fontWeight: 600,
    fontFamily: "Montserrat",
    color: "#3e4a59",
  },
  headingTwo: {
    color: "rgba(86, 58, 150, 1)",
    fontSize: "40px",
    fontWeight: "600",
    fontFamily: "Montserrat",
  },
  requestsStatusTy: {
    backgroundColor: "#816aaf",
    color: "white",
    fontFamily: "Montserrat",
    padding: "10px 10px",
    borderRadius: "8px",
    fontWeight: 600,
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  rightRotated: { transform: "rotate(-90deg)" },
  upperDisplay: {
    width: "86%",
    marginTop: "25px",
    padding: "25px 50px",
    background:
      "linear-gradient(90deg, rgba(222, 212, 245,0.8130602582830007) 0%, rgba(247,243,255,1) 100%)",
  },
  messageIconWrapper: {
    height: "100%",
    display: "flex",
    justifyContent: "left",
    alignItems: "center",
    borderRadius: "px",
  },
  lineWithDotContainer: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      margin: "15px 0",
    },
  },
  lineWithDotUpper: {
    color: "#277acc",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "16px",
  },
  lineWithDot: {
    maxWidth: "none",
    maxHeight: "none",
    width: "150px",
    height: "10px",
    marginLeft: 0,
  },
  lineWithDotLower: {
    color: "#816aaf",
    fontWeight: "bold",
    textAlign: "left",
    fontSize: "14px",
  },
  newMessageButtonWrapper: {
    display: "flex !important",
    justifyContent: "flex-end !important",
  },
  machines: {
    position: "absolute",
    height: "400px",
    bottom: 40,
    right: 20,
  },
  filterContainer2: {
    padding: "10px",
    display: "flex",
  },
  select: {
    fontSize: "16px",
    width: "100%",
    whiteSpace: "nowrap",
    textAlign: "left",
  },
  cursorOnHover: {
    "&:hover": {
      cursor: "pointer",
    },
    [theme.breakpoints.down("md")]: {
      margin: "15px 0",
    },
  },
  lowerButtonsContainer: {
    padding: "0 35%",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  sendRequestButton: {
    height: "88.0781px !important",
    maxWidth: "none",
  },
  tableContainer: {
    // padding: "10px 10px 20px 10px",
    margin: "0 7% 50px 7%",
  },
  upperDisplayButtonsContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  filterContainer: {
    padding: "40px 7% 0 7%",
    display: "flex",
    alignItems: "center",
  },
  selectContainer: {
    display: "flex",
    justifyContent: "right",
    [theme.breakpoints.down("md")]: {
      marginBottom: "10px",
    },
  },
  rightRotated: { transform: "rotate(-90deg)" },
}));
const CohortApplicationMentor = (props) => {
  const html = document.getElementsByTagName("html")[0];
  const {
    getNamesList,
    getNamesListData,
    getMentorCohortApplicationList,
    getCohortApplicationCounter,
    getTableCounterData,
    getTableData,
  } = props;
  // const imageUrl = "https://uat-nmp-api.startupindia.gov.in/v1/document/;";
  const [activeText, setActiveText] = useState(false);
  const [activeText0, setActiveText0] = useState(false);
  const [activeText2, setActiveText2] = useState(false);
  const [activeText3, setActiveText3] = useState(false);
  const [activeText4, setActiveText4] = useState(false);
  const [activeText5, setActiveText5] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [selectedRow, setSelectedRow] = useState("");

  const [mentorShipReqData, setMentorShipReqData] = useState();
  const [tableList, setTableList] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState();
  const history = useHistory();
  const [nameListValue, setNameListValue] = useState([]);
  const [filterCohortId, setFilterCohortId] = useState("");
  const [cohortnameList, setcohortnameList] = useState([]);
  const [cohortnameId, setcohortnameId] = useState([]);
  const handleLoginClick = () => {
    localStorage.setItem("path", "path");
    history.push({
      pathname: "/cohort-form",
      state: {
        fromPage: "cohort-application",
        data: JSON.parse(localStorage.getItem("SavedLoggedInData")),
        mode: "create",
      },
    });
  };

  const defaultFormData = {
    search: "",
    industry: null,
    specialization: null,
    stage: null,
    recognized: "",
    state: "",
    country: "",
  };

  const newCountryArray = [];
  const newStateArray = [];
  const [selectedStatus, setSelectedStatus] = useState("");
  const [formData, setFormData] = useState(defaultFormData);
  const [newCountryOptions, setNewCountryOptions] = useState(newCountryArray);
  const [newStateOptions, setNewStateOptions] = useState(newStateArray);
  const [newCountrySelect, setNewCountrySelect] = useState(false);
  const [filterIndustry, setFilterIndustry] = useState("");
  const [filterFunction, setFilterFunction] = useState("");
  const [filterStage, setFilterStage] = useState("");
  const [filterState, setFilterState] = useState("");
  const [filterCountry, setFilterCountry] = useState("");
  const [cohortfilterGo, setcohortfilterGo] = useState(false);
  const [Heading, setHeading] = useState();
  const [InstructionswithRole, setInstructionswithRole] = useState();
  const [SelectPage, setSelectPage] = useState();
  const [isShown, setIsShown] = useState(false);
  const setModalIsOpenToTrue = () => {
    setIsShown(!isShown);
  };

  const {
    getStartupApplication,
    startUpApplication,
    startUpApplicationPagineate,
    getCountersStartUpList,
    getCounterStartUp,
    getPredefineOptionsList,
    getPredefineOptions,
    getTableDataPaginate,
    getStepperTooltipData,
    getStepperData,
  } = props;
  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));

  const loginrole = JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role;
  if (loginrole === "Mentor" && !localStorage.getItem("setloggedin")) {
    localStorage.setItem("cohortApplicationMentor", "cohortApplicationMentor");
  } else if (loginrole === "Mentor" && localStorage.getItem("setloggedin")) {
    localStorage.removeItem("cohortApplicationMentor");
  } else {
    localStorage.removeItem("cohortApplicationMentor");
    history.push("/startup-dashboard");
  }

  useEffect(() => {
    html.style.overflow = "auto";

    setTimeout(() => {
      localStorage.removeItem("mentorMentorships");
      localStorage.removeItem("cohortMentors");
      localStorage.removeItem("cohortStartup");
      localStorage.removeItem("myrequestMenu");
      localStorage.removeItem("startupListMentor");
      localStorage.removeItem("cohortAdminMentorships");
      localStorage.removeItem("CohortMentorRequest");
      localStorage.removeItem("cohortProgram");
      localStorage.removeItem("cohortMatchTable");
    }, 1000);
    localStorage.removeItem("path");
    // axios({
    //   url: COHORT_NAME_LIST,
    //   method: "post",
    //   data: {
    //     mentorId:
    //       localStorage.getItem("SavedLoggedInData") &&
    //       JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    //   },
    // })
    api
      .POST(COHORT_NAME_LIST, {
        mentorId:
          localStorage.getItem("SavedLoggedInData") &&
          JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      })
      .then((res) => {
        res.data.data &&
          res.data.data.map((item, index) => {
            if (index === 0) {
              let arr2 = {
                label: "Select Cohort Name",
                value: "select",
              };
              setcohortnameList((oldArray) => [...oldArray, arr2]);
            }
            if (item.name !== "" && item.name !== null) {
              let arr = {
                label: item.name,
                value: item.id,
              };
              if (res.data.data.length >= cohortnameList.length)
                setcohortnameList((oldArray) => [...oldArray, arr]);
            }
          });
      })
      .catch((err) => {});
    // axios({
    //   url: COHORT_NAME_LIST,
    //   method: "post",
    //   data: {
    //     status: "VERIFIED",
    //     mentorId:
    //       localStorage.getItem("SavedLoggedInData") &&
    //       JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    //   },
    // })
    api
      .POST(COHORT_NAME_LIST, {
        status: "VERIFIED",
        mentorId:
          localStorage.getItem("SavedLoggedInData") &&
          JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      })
      .then((res) => {
        res.data.data &&
          res.data.data.map((item, index) => {
            if (index === 0) {
              let arr2 = {
                label: "Select Cohort Id",
                value: "select",
              };
              setcohortnameId((oldArray) => [...oldArray, arr2]);
            }
            let arr = {
              label: `C${item.id.slice(-6)}`,
              value: item.id,
            };
            if (res.data.data.length >= cohortnameId.length)
              setcohortnameId((oldArray) => [...oldArray, arr]);
          });
      })
      .catch((err) => {});
  }, []);
  const getTableDataStatus2 = (status) => {
    let params = {
      sortKey: "name",
      sortOrder: "ASC",
      country: null,
      status: status,
      industry:
        filterIndustry && filterIndustry == "select" ? "" : filterIndustry,
      function:
        filterFunction && filterFunction == "select" ? "" : filterFunction,
      stage: filterStage && filterStage == "select" ? "" : filterStage,
      cohortId: filterCohortId == "select" ? "" : filterCohortId,
      searchField: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      searchKey: null,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "date_applied",
        sortOrder: "DESC",
      },
    };
    getMentorCohortApplicationList(params);
  };
  useEffect(() => {
    if (props?.location?.state?.requestStatus === undefined) {
      setActiveText(true);
    } else if (props?.location?.state?.requestStatus === "pending") {
      setActiveText2(true);
    } else if (props.location.state.requestStatus === "viewAll") {
      setActiveText(true);
    } else setActiveText(true);
  }, []);
  useEffect(() => {
    let params = {
      listKey: "Startup",
    };
    getNamesList(params);
  }, []);
  useEffect(() => {
    let params = {
      cohortId: filterCohortId,
      sortKey: "name",
      sortOrder: "ASC",
      country: null,
      industry:
        filterIndustry && filterIndustry == "select" ? "" : filterIndustry,
      function:
        filterFunction && filterFunction == "select" ? "" : filterFunction,
      stage: filterStage && filterStage == "select" ? "" : filterStage,
      searchField: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      searchKey: null,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "date_applied",
        sortOrder: "DESC",
      },
    };
    getMentorCohortApplicationList(params);
  }, [cohortfilterGo]);
  useEffect(() => {
    getNamesListData?.forEach((element, index) => {
      if (index === 0) {
        let arr2 = {
          value: "Select",
          label: "Select Startup",
        };
        setNameListValue((oldArray) => [...oldArray, arr2]);
      }
      let arr = {
        value: element.id,
        label: element.name,
      };
      if (getNamesListData.length >= nameListValue.length)
        setNameListValue((oldArray) => [...oldArray, arr]);
    });
  }, [getNamesListData]);
  useEffect(() => {
    let params = {
      mentorId: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    };
    getCohortApplicationCounter(params);
  }, []);

  const approvalOptions = [
    {
      value: "Approve",
      label: "Approve",
    },
    { value: "Reject", label: "Reject" },
    { value: "Request Info", label: "Request Info" },
  ];
  const tempVar = {
    no: "1",
    name: "Sample Cohort",
    appID: "A21232",
    appDate: "29-08-2022",
    cohortID: "C14698",
    appStatus: "",
    comments: "Sample Comment",
  };
  const newList = [];
  newList.push(tempVar);
  useEffect(() => {
    getPredefineOptionsList();
    Country.getAllCountries().map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newCountryArray.push(newObject);
      setNewCountryOptions(newCountryArray);
    });
    State.getStatesOfCountry("IN").map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newStateArray.push(newObject);
      setNewStateOptions(newStateArray);
    });
  }, []);

  const customStyles = {
    option: (provided, state) => ({
      ...provided,

      textAlign: "left",
    }),
    menu: (base) => ({
      ...base,
      width: "max-content",
      minWidth: "100%",
      fontSize: "14px",
    }),
  };
  useEffect(() => {
    getPredefineOptionsList();
  }, []);
  useEffect(() => {
    getStepperTooltipData();
  }, []);
  useEffect(() => {
    setHeading(getStepperData?.Guidedinstructions[0].Heading);
    setInstructionswithRole(
      getStepperData?.Guidedinstructions[0].InstructionswithRole
    );
    setSelectPage(getStepperData?.Guidedinstructions[0].SelectPage);
  }, [getStepperData]);
  useEffect(() => {
    if (
      history?.location?.state?.fromModule !== undefined &&
      history?.location?.state?.fromModule === "cohortApplicationPending"
    ) {
      setActiveText2(true);
      setActiveText(false);
      setActiveText3(false);
      setActiveText4(false);
      setActiveText5(false);
    } else {
    }
  }, []);
  const ViewApplication = (item) => {
    let reRoute = window.open(`/view-CohortApplication/${item}`, "_blank");
    reRoute.id = item;

    reRoute.fromModule = "ViewApplicationCohort";
  };

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    let params = {
      requestedBy: "",
      status: selectedStatus,
      pageFilter: {
        currentPage: pageNumber - 1,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchField: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      searchKey: null,
      country: "",
      state: formData.state == "select" ? null : formData?.state?.value, // optional
      industry: formData.industry == "select" ? "" : formData?.industry?.value, // optional
      function: formData.function == "select" ? "" : formData?.function?.value, // optional
      stage: formData.stage == "select" ? "" : formData?.stage?.value,
    };
    getMentorCohortApplicationList(params);
  };

  useEffect(() => {
    setTableList(startUpApplication);
    let data = startUpApplication?.requestJson;
    setMentorShipReqData(data);
  }, [startUpApplication]);

  const getTableDataStatus = (status) => {
    let params = {
      sortKey: "name",
      sortOrder: "ASC",
      country: null,

      status: status,
      industry:
        filterIndustry && filterIndustry == "select" ? "" : filterIndustry,
      function:
        filterFunction && filterFunction == "select" ? "" : filterFunction,
      stage: filterStage && filterStage == "select" ? "" : filterStage,
      searchField: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      searchKey: null,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "date_applied",
        sortOrder: "DESC",
      },
    };
    getMentorCohortApplicationList(params);
  };
  return (
    <>
      <div
        // className="mentorlistmaindiv"
        className="chrtadminchrtapplimaindiv"
      >
        <div className="dashboard-main2" style={{ background: "none" }}>
          <div
            className="dashboard-bottom-btn4 topbackbtnmentorlist"
            style={{ background: "transparent", border: "none" }}
          >
            <div className="newuserTooltip">
              <MaterialButton
                className="topbackbtnactual top-btn"
                variant="contained"
                color="primary"
                onClick={() => {
                  props.setSelectedMenu("adminMenu");
                  history.push("/dashboard");
                }}
                style={{ background: "#3ac2d7" }}
              >
                {" "}
                Back
              </MaterialButton>
              <span
                className="tooltiptext tooltip-bottom"
                style={{
                  top: "69px",
                  width: "200px",
                  left: "71px",
                }}
              >
                Click to Go My Dashboard
              </span>
            </div>
            <Modal
              modalOpen={modalOpen}
              setModalOpen={setModalOpen}
              modalData={modalData}
            />
          </div>

          <div className="iconWith-heading cohortappiconwith">
            <div style={{ width: "100%" }}>
              <h3
                className="sub-heading fadeInDown wow"
                style={{ color: "#262838", fontWeight: 600, fontSize: "28px" }}
              >
                MAARG Portal by Startup India
              </h3>
              <h3 className="dashboard-sub-heading fadeInDown wow">
                COHORT ADMIN: COHORT APPLICATIONS
              </h3>
            </div>
            <div
              className="tooltipshow eyeIcon"
              // onClick={() => {
              //   // html.style.overflow = "hidden";
              //   if (html.style.overflow == "auto") {
              //     html.style.overflow = "hidden";
              //   } else {
              //     html.style.overflow = "auto";
              //   }
              // }}
            >
              <div className="newuserTooltip">
                <img
                  className="iconbtn top-btn"
                  src={iconTooltip}
                  onClick={() => {
                    setModalIsOpenToTrue();
                    if (html.style.overflow == "auto") {
                      html.style.overflow = "hidden";
                    } else {
                      html.style.overflow = "auto";
                    }
                  }}
                  width={60}
                />
                <span
                  className="tooltiptext tooltip-bottom "
                  style={{ width: "130px", top: "50px", left: "20px" }}
                >
                  View Instructions
                </span>
              </div>
            </div>
            {isShown && (
              <div>
                <AnimeList
                  setModalIsOpenToTrue={setModalIsOpenToTrue}
                  Heading={Heading}
                  InstructionswithRole={InstructionswithRole}
                  SelectPage={SelectPage}
                />
              </div>
            )}
          </div>
        </div>

        <div className="col-md-11 display-center mobileviewcohortappli">
          <div className="admin-bottom-cardNew row mobileviewmentorbelow">
            <div className="cohortapplimobilediv">
              <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 mentorAppButton">
                <div className="dashboard-bottom-btn2">
                  <p className="text-white2"> APPLICATION STATUS</p>
                </div>
              </div>
              <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 newuserTooltip">
                <p
                  onClick={() => {
                    setActiveText0(true);
                    setActiveText(false);
                    setActiveText2(false);
                    setActiveText3(false);
                    setActiveText4(false);
                    setActiveText5(false);
                    getTableDataStatus("DRAFT");
                    setSelectedStatus("DRAFT");
                  }}
                  style={{
                    color: activeText0 ? "#277acc" : "#838186",
                  }}
                  className="admindasheaderoptions00 applicationHeading040 "
                >
                  DRAFTS : {getTableCounterData && getTableCounterData.draft}
                </p>
                <span
                  className="tooltiptext   tooltip-bottom"
                  style={{ left: "25px", width: "230px" }}
                >
                  Click to View Draft Applications
                </span>
                {activeText0 ? (
                  <img
                    className="requestStatusBar statusBarLine02"
                    src={LineWithDot}
                  />
                ) : (
                  ""
                )}
              </div>
              <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 newuserTooltip">
                <p
                  onClick={() => {
                    setActiveText0(false);
                    setActiveText(true);
                    setActiveText2(false);
                    setActiveText3(false);
                    setActiveText4(false);
                    setActiveText5(false);
                    getTableDataStatus("");
                    setSelectedStatus("");
                  }}
                  style={{
                    color: activeText ? "#277acc" : "#838186",
                  }}
                  className="admindasheaderoptions00 applicationHeading9003"
                >
                  TOTAL APPLICATIONS :{" "}
                  {getTableCounterData && Math.abs(getTableCounterData.total)}
                </p>
                <span
                  className="tooltiptext   tooltip-bottom"
                  style={{ left: "52px", width: "250px", top: "35px" }}
                >
                  Click to View Total Applications
                </span>
                {activeText ? (
                  <img
                    className="requestStatusBar statusBarLine89"
                    src={LineWithDot}
                  />
                ) : (
                  ""
                )}
              </div>

              <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 newuserTooltip pendingPurpleBoxFix mblpendngchrtadahrtapplimbl">
                <p
                  onClick={() => {
                    setActiveText0(false);
                    setActiveText2(true);
                    setActiveText(false);
                    setActiveText3(false);
                    setActiveText4(false);
                    setActiveText5(false);
                    setSelectedStatus("PENDING");
                    getTableDataStatus("PENDING");
                  }}
                  style={{
                    color: activeText2 ? "#277acc" : "#838186",
                    // marginLeft: "-2.3em",
                  }}
                  className="admindasheaderoptions00 applicationHeading2"
                >
                  {" "}
                  PENDING APPROVAL :{" "}
                  {getTableCounterData && Math.abs(getTableCounterData.pending)}
                </p>
                <span className="tooltiptext   tooltip-bottom apprival-applin">
                  Click to View Pending Approval Applications
                </span>
                {activeText2 ? (
                  <img
                    className="requestStatusBar positionBar92"
                    src={LineWithDot}
                  />
                ) : (
                  ""
                )}
              </div>
              <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 newuserTooltip">
                <p
                  onClick={() => {
                    setActiveText0(false);
                    setActiveText2(false);
                    setActiveText(false);
                    setActiveText3(true);
                    setActiveText4(false);
                    setActiveText5(false);
                    setSelectedStatus("REQUESTINFO");
                    getTableDataStatus("REQUESTINFO");
                  }}
                  style={{
                    color: activeText3 ? "#277acc" : "#838186",
                    // marginLeft: "-7em",
                  }}
                  className="admindasheaderoptions00 applicationHeading2 mblpendngchrtadahrtapplimblpara"
                >
                  {" "}
                  REQUESTED INFO :{" "}
                  {getTableCounterData &&
                    Math.abs(getTableCounterData.requestInfo)}
                </p>
                <span className="tooltiptext   tooltip-bottom mentor-04">
                  Click to View Requested Info Applications
                </span>
                {activeText3 ? (
                  <img
                    className="requestStatusBar positionBar89"
                    src={LineWithDot}
                  />
                ) : (
                  ""
                )}
              </div>

              <div className="col-xs-6 col-sm-6 col-md-2 col-lg-1 startUpDashBox2 newuserTooltip mblapprovedchrtadahrtapplimbl">
                <p
                  onClick={() => {
                    setActiveText0(false);
                    setActiveText3(false);
                    setActiveText(false);
                    setActiveText2(false);
                    setActiveText4(true);
                    setActiveText5(false);
                    getTableDataStatus("APPROVED");

                    setSelectedStatus("APPROVED");
                  }}
                  style={{
                    color: activeText4 ? "#277acc" : "#838186",
                    // marginLeft: "-4em",
                  }}
                  className="admindasheaderoptions00 applicationHeading3"
                >
                  {" "}
                  APPROVED :{" "}
                  {getTableCounterData &&
                    Math.abs(getTableCounterData.approved)}
                </p>
                <span className="tooltiptext   tooltip-bottom approved-applin">
                  Click to View Approved Applications
                </span>
                {activeText4 ? (
                  <img
                    className="requestStatusBar positionBar92"
                    src={LineWithDot}
                  />
                ) : (
                  ""
                )}
              </div>
              <div className="col-xs-6 col-sm-6 col-md-2 col-lg-1 newuserTooltip startUpDashBox3">
                <p
                  onClick={() => {
                    setActiveText0(false);
                    setActiveText3(false);
                    setActiveText(false);
                    setActiveText2(false);
                    setActiveText4(false);
                    setActiveText5(true);
                    getTableDataStatus("REJECTED");
                    setSelectedStatus("REJECTED");
                  }}
                  style={{
                    color: activeText5 ? "#277acc" : "#838186",
                    // marginLeft: "-7.5em",
                  }}
                  className="admindasheaderoptions00 rejctdchrtadmnchrtapplimbl"
                >
                  {" "}
                  REJECTED : 0
                </p>
                <span className="tooltiptext   tooltip-bottom mentor-03">
                  Click to View Rejected Applications
                </span>
                {activeText5 ? (
                  <img
                    className="requestStatusBar statusBarLine93"
                    src={LineWithDot}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>

            <div className="row cohortapplideskdiv">
              <div className="col-1 mentorAppButton">
                <div className="dashboard-bottom-btn2">
                  <p className="text-white2"> APPLICATION STATUS</p>
                </div>
              </div>
              <div className="col-9  d-flex justify-content-between align-items-center">
                <div className="col-xs-6 col-sm-6 col-md-2 col-lg-1 newuserTooltip">
                  <p
                    onClick={() => {
                      setActiveText0(true);
                      setActiveText(false);
                      setActiveText2(false);
                      setActiveText3(false);
                      setActiveText4(false);
                      setActiveText5(false);
                      getTableDataStatus("DRAFT");
                      setSelectedStatus("DRAFT");
                    }}
                    style={{
                      color: activeText0 ? "#277acc" : "#838186",
                    }}
                    className="admindasheaderoptions00 applicationHeading040 "
                  >
                    DRAFTS : {getTableCounterData && getTableCounterData.draft}
                  </p>
                  <span
                    className="tooltiptext   tooltip-bottom"
                    style={{ left: "25px", width: "230px" }}
                  >
                    Click to View Draft Applications
                  </span>
                  {activeText0 ? (
                    <img
                      className="requestStatusBar statusBarLine02"
                      src={LineWithDot}
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-xs-6 col-sm-6 col-md-2 col-lg-1 newuserTooltip">
                  <p
                    onClick={() => {
                      setActiveText0(false);
                      setActiveText(true);
                      setActiveText2(false);
                      setActiveText3(false);
                      setActiveText4(false);
                      setActiveText5(false);
                      getTableDataStatus("");
                      setSelectedStatus("");
                    }}
                    style={{
                      color: activeText ? "#277acc" : "#838186",
                    }}
                    className="admindasheaderoptions00 applicationHeading9003"
                  >
                    TOTAL <br></br> APPLICATIONS :{" "}
                    {getTableCounterData && Math.abs(getTableCounterData.total)}
                  </p>
                  <span
                    className="tooltiptext   tooltip-bottom"
                    style={{ left: "30px", width: "250px", top: "50px" }}
                  >
                    Click to View Total Applications
                  </span>
                  {activeText ? (
                    <img
                      className="requestStatusBar statusBarLine89"
                      src={LineWithDot}
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-xs-6 col-sm-6 col-md-2 col-lg-1 newuserTooltip pendingPurpleBoxFix">
                  <p
                    onClick={() => {
                      setActiveText0(false);
                      setActiveText2(true);
                      setActiveText(false);
                      setActiveText3(false);
                      setActiveText4(false);
                      setActiveText5(false);
                      setSelectedStatus("PENDING");
                      getTableDataStatus("PENDING");
                    }}
                    style={{ color: activeText2 ? "#277acc" : "#838186" }}
                    className="admindasheaderoptions00 applicationHeading3"
                  >
                    {" "}
                    PENDING <br></br> APPROVAL :{" "}
                    {getTableCounterData &&
                      Math.abs(getTableCounterData.pending)}
                  </p>
                  <span
                    className="tooltiptext   tooltip-bottom"
                    style={{ left: "24px", width: "300px" }}
                  >
                    Click to View Pending Approval Applications
                  </span>
                  {activeText2 ? (
                    <img
                      className="requestStatusBar positionBar090"
                      src={LineWithDot}
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-xs-6 col-sm-6 col-md-2 col-lg-1 newuserTooltip">
                  <p
                    onClick={() => {
                      setActiveText0(false);
                      setActiveText2(false);
                      setActiveText(false);
                      setActiveText3(true);
                      setActiveText4(false);
                      setActiveText5(false);
                      setSelectedStatus("REQUESTINFO");
                      getTableDataStatus("REQUESTINFO");
                      // getStartupApplicationTable("PENDING");
                      // getMentorApplications("PENDING");
                    }}
                    style={{ color: activeText3 ? "#277acc" : "#838186" }}
                    className="admindasheaderoptions00 applicationHeading2"
                  >
                    {" "}
                    REQUESTED <br></br> INFO :{" "}
                    {getTableCounterData &&
                      Math.abs(getTableCounterData.requestInfo)}
                  </p>
                  <span
                    className="tooltiptext   tooltip-bottom"
                    style={{ left: "7px", width: "20vw" }}
                  >
                    Click to View Requested Info Applications
                  </span>
                  {activeText3 ? (
                    <img
                      className="requestStatusBar positionBar89"
                      src={LineWithDot}
                    />
                  ) : (
                    ""
                  )}
                </div>

                <div className="col-xs-6 col-sm-6 col-md-2 col-lg-1 startUpDashBox2 newuserTooltip">
                  <p
                    onClick={() => {
                      setActiveText0(false);
                      setActiveText3(false);
                      setActiveText(false);
                      setActiveText2(false);
                      setActiveText4(true);
                      setActiveText5(false);
                      getTableDataStatus("APPROVED");
                      setSelectedStatus("APPROVED");
                    }}
                    style={{ color: activeText4 ? "#277acc" : "#838186" }}
                    className="admindasheaderoptions00 applicationHeading2"
                  >
                    {" "}
                    APPROVED :{" "}
                    {getTableCounterData &&
                      Math.abs(getTableCounterData.approved)}
                  </p>
                  <span
                    className="tooltiptext   tooltip-bottom"
                    style={{ left: "30px", width: "250px" }}
                  >
                    Click to View Approved Applications
                  </span>
                  {activeText4 ? (
                    <img
                      className="requestStatusBar positionBar92"
                      src={LineWithDot}
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-xs-6 col-sm-6 col-md-2 col-lg-1 newuserTooltip ">
                  <p
                    onClick={() => {
                      setActiveText0(false);
                      setActiveText3(false);
                      setActiveText(false);
                      setActiveText2(false);
                      setActiveText4(false);
                      setActiveText5(true);
                      getTableDataStatus("REJECTED");
                      setSelectedStatus("REJECTED");
                    }}
                    style={{ color: activeText5 ? "#277acc" : "#838186" }}
                    className="admindasheaderoptions00 applicationHeading02"
                  >
                    {" "}
                    REJECTED : 0
                  </p>
                  <span
                    className="tooltiptext   tooltip-bottom"
                    style={{ left: "-3rem", width: "250px" }}
                  >
                    Click to View Rejected Applications
                  </span>
                  {activeText5 ? (
                    <img
                      className="requestStatusBar statusBarLine93"
                      src={LineWithDot}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
          <Box
            style={{
              justifyContent: "center",
              width: "100%",
              flexWrap: "wrap",
            }}
            className="btnsboxnew"
          >
            <>
              <div
                className="dashboard-purple-btn top-btn newuserTooltip col-sm-12 col-md-6 purpleBtnWidthFix"
                // style={{
                //   width: "300px",
                //   cursor: "pointer",
                // }}
                onClick={() => handleLoginClick()}
              >
                <div
                  className="blue-link-dashboard purpleBtnTextWidthFix createCOhort"
                  // style={{
                  //   paddingRight: "0px",
                  //   fontSize: "16px",
                  //   fontWeight: "600",
                  //   paddingTop: "2px",
                  // }}
                >
                  {" "}
                  CREATE A COHORT
                </div>
                <span
                  className="tooltiptext tooltip-bottom"
                  style={{ left: "100px", top: "60px", width: "220px" }}
                >
                  Click to Create A Cohort
                </span>
              </div>
              <div
                className="dashboard-purple-btn top-btn newuserTooltip col-sm-12 col-md-6 purpleBtnWidthFix"
                onClick={() => {
                  history.push({
                    pathname: "/dashboard",
                    state: {
                      fromModule: "cohortMentorApplication",
                    },
                  });
                  props.setSelectedMenu("cohortProgram");
                }}
              >
                <div
                  className="blue-link-dashboard purpleBtnTextWidthFix createCOhort"
                  // style={{
                  //   paddingRight: "0px",
                  //   fontWeight: "600",
                  //   fontSize: "16px",
                  // }}
                >
                  {" "}
                  VIEW COHORT PROGRAMS
                </div>
                <span
                  className="tooltiptext tooltip-bottom"
                  style={{ left: "100px", top: "60px", width: "220px" }}
                >
                  Click to View Cohort Programs
                </span>
              </div>{" "}
            </>
          </Box>

          <div className="filter-row filter-row-common filterDivMentorapp">
            <div>
              <form className="formContainer newfilterdivnow">
                <div className="row desktopFilterRow">
                  <div className="col-11 d-flex justify-content-between filter-bigDiv">
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip">
                      <Select
                        required={true}
                        id="cohortorgname"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="cohortorgname"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.cohortorgname}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              cohortorgname: e.value == "select" ? null : e,
                            };
                          });
                          setFilterCohortId(e.value);
                        }}
                        options={cohortnameList}
                        placeholder="Cohort Name"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "90px", top: "45px", width: "140px" }}
                      >
                        Search Cohort Name
                      </span>
                    </div>
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip">
                      <Select
                        required={true}
                        id="cohortId"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="cohortId"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.cohortId}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              cohortId: e.value == "select" ? null : e,
                            };
                          });
                          setFilterCohortId(e.value);
                        }}
                        options={cohortnameId}
                        placeholder="Cohort ID"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "90px", top: "45px", width: "130px" }}
                      >
                        Search Cohort ID
                      </span>
                    </div>
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip">
                      <Select
                        required={true}
                        id="Industry"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="industry"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.industry}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              industry: e.value == "select" ? null : e,
                            };
                          });
                          setFilterIndustry(e.value);
                        }}
                        options={getPredefineOptions?.industry_options}
                        placeholder="Industry"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "90px", top: "45px", width: "130px" }}
                      >
                        Search Industry
                      </span>
                    </div>
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip">
                      <Select
                        required={true}
                        id="specialization"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="specialization"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.function}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              function: e.value == "select" ? null : e,
                            };
                          });
                          setFilterFunction(e.value);
                        }}
                        options={getPredefineOptions?._specialisation}
                        placeholder="Function"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "90px", top: "45px", width: "130px" }}
                      >
                        Search Function
                      </span>
                    </div>

                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip">
                      <Select
                        required={true}
                        id="stage"
                        // label="Gender*"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="stage"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.stage}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              stage: e.value == "select" ? null : e,
                            };
                          });
                          setFilterStage(e.value);
                        }}
                        options={getPredefineOptions?.stage_of_startup_options}
                        placeholder="Stage"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "90px", top: "45px", width: "130px" }}
                      >
                        Search Stage
                      </span>
                    </div>
                  </div>

                  <div className="apply-section d-flex justify-content-end col-1 ">
                    <div className="newuserTooltip">
                      <Button
                        onClick={() => getTableDataStatus2(selectedStatus)}
                        text="GO"
                        className="filter-button top-btn newcoloredbtn startupColorBtn"
                      ></Button>
                      <span className="tooltiptext filterAdmin  tooltip-bottom filterAfter">
                        Click to Apply Filters
                      </span>
                    </div>
                  </div>
                </div>

                <div className="row mobileFilterRow">
                  <div className="col-md-1 filter-text">Filter by</div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="cohortorgname"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="cohortorgname"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.cohortorgname}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            cohortorgname: e.value == "select" ? null : e,
                          };
                        });
                        setFilterCohortId(e.value);
                      }}
                      options={cohortnameList}
                      placeholder="Cohort Name"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="cohortId"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="cohortId"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.cohortId}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            cohortId: e.value == "select" ? null : e,
                          };
                        });
                        setFilterCohortId(e.value);
                      }}
                      options={cohortnameId}
                      placeholder="Cohort ID"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="Industry"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="industry"
                      className="col-12 gendermentorinput inputmblresmenreqstrtup"
                      styles={customStyles}
                      value={formData.industry}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            industry: e.value == "select" ? null : e,
                          };
                        });
                        setFilterIndustry(e.value);
                      }}
                      options={getPredefineOptions?.industry_options}
                      placeholder="Industry"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="specialization"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="specialization"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.function}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            function: e.value == "select" ? null : e,
                          };
                        });
                        setFilterFunction(e.value);
                      }}
                      options={getPredefineOptions?._specialisation}
                      placeholder="Function"
                    />
                  </div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="stage"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="stage"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.stage}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            stage: e.value == "select" ? null : e,
                          };
                        });
                        setFilterStage(e.value);
                      }}
                      options={getPredefineOptions?.stage_of_startup_options}
                      placeholder="Stage"
                    />
                  </div>
                  {/* <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="country"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="country"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.country}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            country: e.value == "select" ? null : e,
                          };
                        });

                        setFilterCountry(e.label);

                        if (e.label === "India") {
                          setNewCountrySelect(true);
                        } else {
                          setNewCountrySelect(false);
                        }
                        setNewStateOptions("");
                      }}
                      options={newCountryOptions}
                      placeholder="Country"
                    />
                  </div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="state"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="state"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.state}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            state: e.value == "select" ? null : e,
                          };
                        });
                        setFilterState(e.value);
                      }}
                      options={newStateOptions}
                      placeholder="State"
                    />
                  </div> */}
                  <div
                    className="col-md-1 apply-section"
                    style={{ color: "transparent" }}
                  >
                    <Button
                      className="green-btn filter-btn"
                      text="GO"
                      onClick={() => getTableDataStatus2(selectedStatus)}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div className="totalTableCount">
            Total Cohort Applications : {getTableDataPaginate?.totalElements}{" "}
            &lt; {getTableDataPaginate?.currentPage} of{" "}
            {getTableDataPaginate?.numPages} &gt;{" "}
          </div>
          {getTableData && getTableData?.length > 0 ? (
            <div>
              <div className="table-container mt-2">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th
                        style={{ verticalAlign: "middle" }}
                        className="fixColumbnWidth4"
                      >
                        {" "}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",

                            minWidth: "20px",
                          }}
                        >
                          NO.
                        </div>
                      </th>
                      <th
                        className="fixColumbnWidth"
                        colspan="2"
                        style={{ verticalAlign: "middle" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                          }}
                        >
                          COHORT DETAILS
                        </div>
                      </th>
                      <th
                        className="fixColumbnWidth4"
                        style={{
                          whitespace: "nowrap",
                          verticalAlign: "middle",
                          fontSize: "15.3px",
                          minWidth: "9.4rem",
                          maxWidth: "9.5rem",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                          }}
                        >
                          APPLICATION ID <br />& DATE
                        </div>
                      </th>
                      <th
                        className="fixColumbnWidth4"
                        style={{
                          whitespace: "nowrap",
                          verticalAlign: "middle",
                          fontSize: "15.3px",
                          minWidth: "7.4rem",
                          maxWidth: "9.5rem",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                          }}
                        >
                          COHORT ID
                        </div>
                      </th>
                      <th
                        className="fixColumbnWidth7"
                        style={{ minWidth: "6.9rem", verticalAlign: "middle" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                          }}
                        >
                          APPLICATION STATUS
                        </div>
                      </th>
                      <th
                        className="fixColumbnWidth7"
                        style={{
                          minWidth: "10.9rem",
                          maxWidth: "11rem",
                          verticalAlign: "middle",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                          }}
                        >
                          COMMENTS
                        </div>
                      </th>
                      <th
                        className="fixColumbnWidth7"
                        style={{ verticalAlign: "middle" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                          }}
                        >
                          EDIT
                        </div>
                      </th>
                    </tr>
                  </thead>
                  {getTableData &&
                    getTableData?.length > 0 &&
                    getTableData.map((item, index) => (
                      <>
                        <tbody>
                          <tr
                            className={
                              item.id === selectedRow ? "purpleBackground" : ""
                            }
                            key={index}
                          >
                            {getTableDataPaginate.currentPage === 1 ? (
                              <td style={{ verticalAlign: "middle" }}>
                                {" "}
                                <div className="srnumberchrtadmnchrtapplimbl">
                                  {index + 1}
                                </div>
                              </td>
                            ) : (
                              <td style={{ verticalAlign: "middle" }}>
                                <div>
                                  {index +
                                    1 +
                                    10 * (getTableDataPaginate.currentPage - 1)}
                                </div>
                              </td>
                            )}
                            <td
                              style={{ verticalAlign: "middle" }}
                              className="chrtdtlschrtadmnchrtapplimbl"
                            >
                              <div
                                className="newuserTooltip"
                                style={{
                                  width: "100px",

                                  maxWidth: "none",

                                  objectFit: "contain",
                                }}
                              >
                                <img
                                  src={
                                    item.uploadBanner === null
                                      ? hashImage
                                      : item.uploadBanner
                                  }
                                  onClick={() =>
                                    window.open(
                                      `/cohort-programs/all/${item?.id}`,
                                      "_blank"
                                    )
                                  }
                                  className="sidebar-dashboard-icon2 chrtdtlsimgchrtapplimbl"
                                  style={{
                                    width: "100%",
                                    // height: "100%",
                                    objectFit: "contain",
                                    cursor: "pointer",
                                  }}
                                />
                                <span
                                  className="tooltiptext tooltip-bottom "
                                  style={{
                                    left: "26px",
                                    top: "88px",
                                    width: "150px",
                                  }}
                                >
                                  {item.applicationStatus === "VERIFIED"
                                    ? "View Cohort Details"
                                    : "View Cohort Preview"}
                                </span>
                                <div
                                  style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    height: "auto",
                                    alignItems: "end",
                                  }}
                                  className="chrtdtlsinnerdivchrtapplimbl"
                                >
                                  <div
                                    style={{
                                      cursor: "default",
                                      alignItems: "center",
                                      display: "flex",
                                      minWidth: "100%",
                                    }}
                                  >
                                    {item.program_name}
                                    <br></br>
                                    {item.organization_name}
                                    <br></br>
                                    Start Date:{" "}
                                    {moment(item?.cohort_date).format(
                                      "DD/MM/YYYY"
                                    )}
                                    <br></br>
                                    Duration: {item.program_duration}
                                    <br></br>
                                  </div>
                                  {item?.applicationStatus === "VERIFIED" && (
                                    <div
                                      className="newuserTooltip"
                                      style={{
                                        cursor: "pointer",
                                        alignItems: "stretch",
                                        justifyContent: "right",
                                        height: "100px",
                                        minWidth: "100%",
                                        display: "flex",
                                      }}
                                    >
                                      <img
                                        src={CohortDetail}
                                        onClick={() =>
                                          window.open(
                                            `/cohort-programs/all/${item?.id}`,
                                            "_blank"
                                          )
                                        }
                                        width="40px"
                                      />
                                      <span
                                        className="tooltiptext tooltip-bottom "
                                        style={{
                                          left: "-4px",
                                          top: "105px",
                                          width: "150px",
                                        }}
                                      >
                                        {item.applicationStatus === "VERIFIED"
                                          ? "View Cohort Details"
                                          : "View Cohort Preview"}
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </td>
                            <td className="chrtadmnapplidetailsdontshowdivmbl">
                              <div
                                style={{
                                  flexDirection: "row",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  height: "auto",
                                  alignItems: "end",
                                }}
                              >
                                <div
                                  style={{
                                    cursor: "default",
                                    alignItems: "center",
                                    display: "flex",
                                    minWidth: "200px",
                                  }}
                                >
                                  {item.program_name}
                                  <br></br>
                                  {item.organization_name}
                                  <br></br>
                                  {item?.cohort_date != null &&
                                    `Start Date:
                                    ${moment(item?.cohort_date).format(
                                      "DD/MM/YYYY"
                                    )}`}
                                  <br></br>
                                  {item?.program_duration != null &&
                                    `Duration: ${item.program_duration}`}
                                  <br></br>
                                </div>
                                {item?.applicationStatus === "VERIFIED" && (
                                  <div
                                    className="newuserTooltip"
                                    style={{
                                      cursor: "pointer",
                                      alignItems: "end",
                                      justifyContent: "center",
                                      height: "100px",
                                      minWidth: "40px",
                                      display: "flex",
                                    }}
                                  >
                                    <img
                                      src={CohortDetail}
                                      onClick={() =>
                                        window.open(
                                          `/cohort-programs/all/${item?.id}`,
                                          "_blank"
                                        )
                                      }
                                    />
                                    <span
                                      className="tooltiptext tooltip-bottom "
                                      style={{
                                        left: "-4px",
                                        top: "105px",
                                        width: "150px",
                                      }}
                                    >
                                      {item.applicationStatus === "VERIFIED"
                                        ? "View Cohort Details"
                                        : "View Cohort Preview"}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </td>

                            <td
                              style={{ verticalAlign: "middle" }}
                              className="chrtadmnappliidanddatembl"
                            >
                              <div className="newuserTooltip">
                                <a
                                  onClick={() => {
                                    ViewApplication(item?.id);
                                  }}
                                  className="color-green"
                                >
                                  {item?.id?.substring(item?.id?.length - 6)}
                                </a>
                                <span
                                  className="tooltiptext tooltip-bottom"
                                  style={{
                                    left: "23px",

                                    width: "180px",
                                  }}
                                >
                                  View Cohort Application
                                </span>
                              </div>
                              <div className="mt-2">
                                {moment(item?.date_applied).format(
                                  "DD/MM/YYYY"
                                )}
                                <br></br>
                                {moment(item?.date_applied).format("hh:mm a")}
                              </div>
                            </td>
                            <td style={{ verticalAlign: "middle" }}>
                              <div className="chrtidchrtapplimobl">
                                {item.applicationStatus === "VERIFIED"
                                  ? item.cohortId !== null &&
                                    item.cohortId !== "" &&
                                    "C" +
                                      item.cohortId.substring(
                                        item.cohortId.length - 6
                                      )
                                  : ""}
                              </div>
                            </td>
                            <td style={{ verticalAlign: "middle" }}>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "left",
                                  alignItems: "center",
                                }}
                                className="appstatuschrtapplimobl"
                              >
                                {item.applicationStatus === "VERIFIED"
                                  ? "APPROVED"
                                  : item.applicationStatus}
                                {item.applicationStatus != "SUBMITTED" && (
                                  <br />
                                )}
                                {item.applicationStatus != "SUBMITTED" &&
                                item.date_updated &&
                                item.date_updated !== null &&
                                item.date_updated !== ""
                                  ? moment(item.date_updated).format(
                                      "DD/MM/YYYY"
                                    )
                                  : ""}
                                {item.applicationStatus != "SUBMITTED" && (
                                  <br />
                                )}
                                {item.applicationStatus != "SUBMITTED" &&
                                item.date_updated &&
                                item.date_updated !== null &&
                                item.date_updated !== ""
                                  ? moment(item.date_updated).format("hh:mm A")
                                  : ""}
                              </div>
                            </td>
                            <td style={{ verticalAlign: "middle" }}>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "left",
                                  alignItems: "center",
                                }}
                              >
                                {item.comments?.length > 75 ? (
                                  <>
                                    {item.comments.substring(0, 75)}
                                    <div className="tooltipicon d-flex">
                                      <svg
                                        style={{
                                          position: "relative",
                                          top: "0.1rem",
                                          cursor: "pointer",
                                        }}
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        fill="currentColor"
                                        className="bi bi-three-dots "
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                                      </svg>
                                      <span
                                        className="tooltiptext8"
                                        style={{ top: "-287px", left: "2px" }}
                                      >
                                        <h5
                                          style={{
                                            fontWeight: 600,
                                            color: "#fff",
                                          }}
                                        >
                                          Comments
                                        </h5>
                                        {item.comments}
                                      </span>
                                    </div>
                                  </>
                                ) : item.comments !== null &&
                                  item.comments !== "" ? (
                                  item.comments
                                ) : (
                                  " "
                                )}
                                {}
                              </div>
                            </td>

                            <td
                              style={{
                                display: "flex",
                                // justifyContent: "center",
                              }}
                              className="commntschrtapplimblshowmb"
                            >
                              <div
                                style={{
                                  cursor: "pointer",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  height: "100px",
                                  width: "50px",
                                  display: "flex",
                                }}
                              >
                                {item.applicationStatus === "VERIFIED" ||
                                item.applicationStatus === "DRAFT" ||
                                item.applicationStatus === "REQUESTINFO" ? (
                                  <div
                                    className="newuserTooltip"
                                    onClick={() => {
                                      if (
                                        item.applicationStatus === "DRAFT" ||
                                        item.applicationStatus === "REQUESTINFO"
                                      ) {
                                        localStorage.setItem("path", "path");
                                      }

                                      history.push({
                                        pathname: `/cohort-form`,
                                        state: { data: item, mode: "edit" },
                                      });
                                    }}
                                  >
                                    <img
                                      src={editIcon}
                                      style={{
                                        width: "80%",
                                        height: "90%",
                                        cursor: "pointer",
                                      }}
                                    />
                                    <span
                                      className="tooltiptext  tooltip-bottom tooltext"
                                      style={{
                                        left: "-35px",
                                        width: "165px",
                                        top: "2.5rem",
                                      }}
                                    >
                                      Edit Cohort Application
                                    </span>
                                  </div>
                                ) : (
                                  " "
                                )}
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </>
                    ))}
                </table>
                <div className="pagination-box">
                  {getTableDataPaginate !== undefined && (
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={10}
                      totalItemsCount={getTableDataPaginate.totalElements}
                      pageRangeDisplayed={5}
                      onChange={handlePageChange.bind(this)}
                    />
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="no-records">No Records Found</div>
          )}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    startUpApplication: state.StartUpReducer.StartUpApplications.data,
    startUpApplicationPagineate:
      state.StartUpReducer.StartUpApplications.paginate,
    getCounterStartUp: state.StartUpReducer.getCountersStartUpList.data,
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    getNamesListData: state.AdminMentorReducer.getNamesList?.data,
    getTableData: state.MentorReducer.getCohortMentorList.data,
    getTableDataPaginate: state.MentorReducer.getCohortMentorList.paginate,
    getTableCounterData:
      state.AdminMentorReducer.getCohortApplicationCounter.data,
    getStepperData: state.AdminMentorReducer.getStepperList.list,
  };
};
export default connect(mapStateToProps, {
  getPredefineOptionsList,
  getNamesList,
  getMentorCohortApplicationList,
  getCohortApplicationCounter,
  getStepperTooltipData,
})(withRouter(CohortApplicationMentor));
